import { jsx as _jsx } from "react/jsx-runtime";
const NextTurnIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("g", Object.assign({ id: "Icon" }, { children: _jsx("path", { id: "Vector", d: "M16 18H18V6H16M6 18L14.5 12L6 6V18Z", fill: props.color }) })) })));
};
NextTurnIcon.defaultProps = {
    color: 'white',
};
export default NextTurnIcon;
